
//import axios from 'axios'
import { createProvider } from '../vue-apollo'
//import Vue from 'vue';
//import gql from "graphql-tag";
import DataServices from "@/core/DataServices";
import graphql from '../views/admin/common/graphql.js'
import gql from "graphql-tag";
//import Config from "@/config";
import Common from './Common';
import moment from "moment-timezone";
import Api from "../core/ApiRepository";
//import GetConstants from './Constants';
//var constants = GetConstants.getConstans();
//import store from '@/store'
//import gql from "graphql-tag";
export default {
    async getListData(table,where,offset=null,limit=null,orderBy=null) {
        var variables = {
            where_key:where ,
        };
        if (offset && limit){
            variables.limit = limit;
            variables.offset = offset;
        }
        if (orderBy){
            variables.orderBy = orderBy;
        }
        var gqLQueryList =await DataServices.getList(table);
        var resData = await createProvider().defaultClient.mutate({
            mutation: gqLQueryList,
            variables: variables
        });
        //var listData = resData.data[table];
        var listData = resData[Object.keys(resData)];
        return listData;
    },
    async getObjectData(table,where) {
        var gqLQueryList =await DataServices.getList(table);
        var resData = await createProvider().defaultClient.mutate({
            mutation: gqLQueryList,
            variables: {
                where_key:where ,
                limit: 1
            }
        });
        var listData = resData.data[table];
        if (listData && listData.length > 0){
            return listData[0];
        }
        return null;
    },
    async getListCodeAgencyCourt(uid) {
        var where_user = {
            id: {_eq: uid}
        }
        var obj_user = await this.getObjectData('accounts', where_user);
        var list_code = [];
        if (obj_user){
            var str_code_agency = obj_user.users.str_code_agency;
            if (str_code_agency){
                list_code = str_code_agency.split(',')
            }
        }
        return list_code;
    },
    async getListVar(modelName,variables) {
        var gqLQueryList =await DataServices.getList(modelName);
        var data = await createProvider().defaultClient.mutate({
            mutation: gqLQueryList,
            variables: variables
        });
        var listData = data[Object.keys(data)];
        return listData;
    },
    async countRecord(modelName,variables) {
        var gqLQueryList =await DataServices.countData(modelName);
        var data = await createProvider().defaultClient.mutate({
            mutation: gqLQueryList,
            variables: variables
        });
        var dataCount = data[Object.keys(data)];
        return dataCount;
    },
    async countRecordListDocs(modelName,variables) {
        var gqLQueryList =await DataServices.countDataListDocs(modelName);
        var data = await createProvider().defaultClient.mutate({
            mutation: gqLQueryList,
            variables: variables
        });
        var dataCount = data[Object.keys(data)];
        return dataCount;
    },
    async getListState() {
        var gqLQueryList =await DataServices.getList('state', {"fields" : "id name type"});
        var {data} = await createProvider().defaultClient.query({
            query: gqLQueryList,
            fetchPolicy: "network-only",
            //variables: variables
        });
        var model = data[Object.keys(data)];
        if (model.length > 0) {
            var listState = [];
            for (let i = 0; i < model.length; i++) {
                listState.push({'code': model[i].id, 'name': model[i].name,'type': model[i].type})
            }
            return listState;
        }
        return [];
    },
    async getListUserState(state_id,limit=null) {
        //Nếu khác TP HCM thì load danh sách tống đạt viên theo tỉnh thành
        var variables_data = {
            where: {
                state_id : {'_eq': state_id},
                user: {
                    users_account: {
                        role: {'_eq': 'tdv'}
                    },
                    active: {_eq: true},
                    deleted: {_eq: false}
                }
            },
            distinct_on: "user_id"
        };
        if (limit){
            variables_data.limit = limit;
        }
        var {data} = await createProvider().defaultClient.query({
            query: gql(graphql.GET_USERS_STATE),
            variables: variables_data,
            fetchPolicy: "network-only"
        })
        var model = data[Object.keys(data)];
        var arrTDV = [];
        if (model.length > 0) {
            for (let i = 0; i < model.length; i++) {
                arrTDV.push({'code': model[i].user_id, 'name': model[i].user.fullname, 'phone' : model[i].user.phone})
            }
        }
        return arrTDV;
    },
    async getListUserWard(ward_id,limit=null) {
        var variables_data = {
            where: {
                ward_id: {'_eq': ward_id},
                user: {
                    users_account: {
                        role: {'_eq': 'tdv'}
                    },
                    active: {_eq: true},
                    deleted: {_eq: false}
                }
            },
            distinct_on: "user_id"
        };
        if (limit){
            variables_data.limit = limit;
        }
        var {data} =  await createProvider().defaultClient.query({
            query: gql(graphql.GET_USERS_WARD),
            variables: variables_data,
            fetchPolicy: "network-only"
        })
        var model = data[Object.keys(data)];
        var arrTDV = [];
        if (model.length > 0) {
            for (let i = 0; i < model.length; i++) {
                arrTDV.push({'code': model[i].user_id, 'name': model[i].user.fullname, 'phone' : model[i].user.phone})
            }
        }
        return arrTDV;
    },

    async getListUserTDV() {
        var {data} =  await createProvider().defaultClient.query({
        query: DataServices.getList('users', {"fields" : "id fullname phone"}),
        variables: {
          where_key: {
          active : {_eq: true},
          users_account: {
            role: {_eq: "tdv"},
            deleted: {_eq: false}
          }, 
          deleted: {_eq: false}
          },
          orderBy: {created_at: 'desc'}
        },
        fetchPolicy: "network-only"
        });
        var model = data[Object.keys(data)];
        if (model.length > 0) {
        var arrTDV = [];
        for (let i = 0; i < model.length; i++) {
          arrTDV.push({'code': model[i].id, 'name': model[i].fullname, 'phone': model[i].phone});
        }
        return arrTDV;
        }
      },
    async getListUserWardByState(state_id,limit=null) {
        var variables_data = {
            where: {
                state_id: {'_eq': state_id},
                user: {
                    users_account: {
                        role: {'_eq': 'tdv'}
                    },
                    active: {_eq: true},
                    deleted: {_eq: false}
                }
            },
            distinct_on: "user_id"
        };
        if (limit){
            variables_data.limit = limit;
        }
        var {data} =  await createProvider().defaultClient.query({
            query: gql(graphql.GET_USERS_WARD),
            variables: variables_data,
            fetchPolicy: "network-only"
        })
        var model = data[Object.keys(data)];
        var arrTDV = [];
        if (model.length > 0) {
            for (let i = 0; i < model.length; i++) {
                arrTDV.push({'code': model[i].user_id, 'name': model[i].user.fullname, 'phone' : model[i].user.phone})
            }
        }
        console.log("arrTDV11111111111111_______________________",arrTDV);
        
        return arrTDV;
    },


    async getAccountByUid(uid) {
        var table_cer = 'accounts';
        var where = {uid: {_eq: uid}};
        var gqLQueryList =await DataServices.getList(table_cer);
        var resData = await createProvider().defaultClient.mutate({
            mutation: gqLQueryList,
            variables: {
                where_key:where ,
            }
        });
        var listData = resData.data[table_cer];
        return listData;
    },
    async getListVPLKByStateVP(state_id,office_tpl_id ) { //Lấy danh sách VPLK theo state và VP

        var queryData = `
        query MyQuery($where_arr: office_vplk_bool_exp) {
          office_vplk(where: {deleted: {_eq: false}}) {
            id
            name
            code
            rel_arr_vplk_salary_pricelist_province(where: {office_tpl_id: {_eq: ${office_tpl_id}}, state_id: {_eq: ${state_id}}}) {
              id
              price
              state_id
              office_tpl_id
            }
          }
        }
        `;
        var {data} = await createProvider().defaultClient.query({
            query: gql(queryData),
           // variables: variables_data,
            fetchPolicy: "network-only"
        })
        var model = data[Object.keys(data)];
        var dataVPLK = [];
        if (model.length > 0) {
            for (let i = 0; i < model.length; i++) {
                //dataVPLK.push({'code': model[i].user_id, 'name': model[i].user.fullname, 'phone' : model[i].user.phone})
                var salary_pricelist_province = model[i].rel_arr_vplk_salary_pricelist_province;
                var price = 0;
                if (salary_pricelist_province.length > 0){
                    //Lấy phần tử thứ 0
                    price = salary_pricelist_province[0].price;
                }
                dataVPLK.push({'code': model[i].id, 'name': model[i].code,'price':price})
            }
        }
        return dataVPLK;
    },
    customFilterCore( itemLabel, filterValue ,dateType) {
        //console.log("itemLabelitemLabel:",itemLabel);
        //console.log("filterValuefilterValue:",filterValue);
        var timezone_vn = 'Asia/Ho_Chi_Minh';
        var checkCondition = true;
        var checkInput = true;
        if (dateType > 0) {
            if (dateType == 1) {
                if (filterValue == undefined) return true;
                /*var date1 = new Date(moment(itemLabel).format('YYYY-MM-DD'));
                var date2 = new Date(moment(filterValue).format('YYYY-MM-DD'));*/
                var date1 = moment(itemLabel).tz(timezone_vn).format('YYYYMMDD');
                var date2 = moment(filterValue).tz(timezone_vn).format('YYYYMMDD');
                checkCondition = (parseFloat(date1) == parseFloat(date2));
            } else if (dateType == 2) {
                //var date3 = new Date(moment(itemLabel).format('YYYY-MM-DD'));
                var date3 = moment(itemLabel).tz(timezone_vn).format('YYYYMMDD');
                if (filterValue != undefined && filterValue.from != undefined && filterValue.from != null && filterValue.to != undefined && filterValue.to != null) {
                    /*var valueFrom = new Date(moment(filterValue.from).format('YYYY-MM-DD'));
                    var valueTo = new Date(moment(filterValue.to).format('YYYY-MM-DD'));*/
                    var valueFrom = moment(filterValue.from).tz(timezone_vn).format('YYYYMMDD');
                    var valueTo = moment(filterValue.to).tz(timezone_vn).format('YYYYMMDD');
                    checkCondition = parseFloat(date3) >= parseFloat(valueFrom) && parseFloat(date3) <= parseFloat(valueTo);//bỏ Number(date3)
                } else if (filterValue != undefined && filterValue.from != undefined && filterValue.from != null) {
                    //var dateFrom = new Date(moment(filterValue.from).format('YYYY-MM-DD'));
                    var dateFrom = moment(filterValue.from).tz(timezone_vn).format('YYYYMMDD');
                    checkCondition = parseFloat(date3) >= parseFloat(dateFrom);
                } else if (filterValue != undefined && filterValue.to != undefined && filterValue.to != null) {
                    /*var dateTo = new Date(moment(filterValue.to).format('YYYY-MM-DD'));
                    checkCondition = Number(date3) <= Number(dateTo);*/
                    var dateTo = moment(filterValue.to).tz(timezone_vn).format('YYYYMMDD');
                    checkCondition = parseFloat(date3) <= parseFloat(dateTo);
                }
            }
        }
        if (filterValue != '' && typeof filterValue != 'object' && itemLabel != undefined) {
            var itemLabelStr = String(itemLabel);
            var filterValueStr = String(filterValue);
            var labelData = itemLabelStr.trim().toLowerCase();
            var labelFilter = filterValueStr.trim().toLowerCase();
            labelData = Common.SkipVN(labelData);
            labelFilter = Common.SkipVN(labelFilter);
            checkInput  = itemLabelStr.indexOf(filterValueStr) >= 0 || labelData.indexOf(labelFilter) >= 0;
        }
        return checkCondition && checkInput;
    },
    convertDateValueDoc(models){
        console.log("modelsmodelsmodels:",models)
        var timezone_vn = 'Asia/Ho_Chi_Minh';
        var format_date = 'DD/MM/YYYY HH:mm';
        return {
            dateReceiptCourt:(!Common.isEmpty(models.date_receipt_court)) ? (moment(models.date_receipt_court).tz(timezone_vn).format(format_date)):null,
            dateTDVReturn:(!Common.isEmpty(models.date_tdv_return)) ? (moment(models.date_tdv_return).tz(timezone_vn).format(format_date)):null,
            dateRequestComplete:(!Common.isEmpty(models.date_request_complete)) ? (moment(models.date_request_complete).tz(timezone_vn).format(format_date)):null,
            dateReturnCourt:(!Common.isEmpty(models.date_return_court)) ? (moment(models.date_return_court).tz(timezone_vn).format(format_date)):null,
            dateTDVReceipt:(!Common.isEmpty(models.date_tdv_receipt)) ? (moment(models.date_tdv_receipt).tz(timezone_vn).format(format_date)):null,
            dateDPVReceipt:(!Common.isEmpty(models.date_dpv_receipt)) ? (moment(models.date_dpv_receipt).tz(timezone_vn).format(format_date)):null,
            dateComplete:(!Common.isEmpty(models.date_complete)) ? (moment(models.date_complete).tz(timezone_vn).format(format_date)):null,
            date_comfirm_salary:(!Common.isEmpty(models.date_comfirm_salary)) ? (moment(models.date_comfirm_salary).tz(timezone_vn).format(format_date)):null,
            date_upd_salary:(!Common.isEmpty(models.date_upd_salary)) ? (moment(models.date_upd_salary).tz(timezone_vn).format(format_date)):null,
            dateChangeTDV :(!Common.isEmpty(models.date_change_tdv)) ? (moment(models.date_change_tdv).tz(timezone_vn).format(format_date)):null,
        };
    },
    async convertFilter(type_input,key,filters) {
        if (type_input == 'DateRange'){
            if (!Common.isEmpty(filters[key]) && !Common.isEmpty(filters[key][0])  && !Common.isEmpty(filters[key][1])) {
                return  {
                    type_input:'DateRange',
                    value:{
                        from : moment(filters[key][0]).utc().format(),//.utc()
                        to : moment(filters[key][1]).utc().add(24, 'hours').format(),//.utc()
                    },
                };
            }else {
                return  {
                    type_input:'DateRange',
                    value:null
                };
            }
        }else {
            return  {
                type_input:type_input,
                value:filters[key],
            };
        }
    },
    async callApiPost(url,params={},header={}) {
        var payloadDefault = {};
        var headerDefaul = {};
        if (!(Object.keys(params).length === 0)){
            for (const [key, value] of Object.entries(params)) {
                payloadDefault[key] = value;
            }
        }
        if (!(Object.keys(header).length === 0)){
            for (const [key_h, value_h] of Object.entries(header)) {
                headerDefaul[key_h] = value_h;
            }
        }
        var config = {
            headers:headerDefaul
        }
        const results = await Api.post(url, payloadDefault,config);
        return results;
    },
    async writeLogApi(name_file,title,dataLog,token) {
        var dataPost = {
            name_file:name_file,
            data_log:dataLog,
            title_log :title
        };
        const headers = {
            "Authorization": "Bearer "+token,
        };
       await this.callApiPost('/_api/common/write-log-check',dataPost, headers);
       return true;

    },
    async getDistrictByIdState(id_state) {
        var resData = await createProvider().defaultClient.mutate({
            mutation: DataServices.getList('district', {"fields" : "id name"}),
            variables: {
                where_key: {
                    state_id: {'_eq': id_state}
                }
            },
        });
        var dataList = resData[Object.keys(resData)];
        var list_district = (dataList["district"]) ? dataList["district"]:[];
        for (var i=0;i<list_district.length;i++){
            list_district[i].value = list_district[i].id;
            list_district[i].label = list_district[i].name;
        }
        return list_district;
    },
    async getDistrictByIdStateSelect(id_state) {
        var model =await this.getDistrictByIdState(id_state);
        var arrDistrict = [];
        if (model.length > 0) {
            for (let i = 0; i < model.length; i++) {
                arrDistrict.push({'code': model[i].id, 'name': model[i].name})
            }
        }
        return arrDistrict;
    },
    async getWardByIdDistrict(id_district,state_id=null) {
        var where_key = {}
        if(state_id){
            where_key={state_id_merger: {'_eq': state_id}}
        }else{
            where_key = {
                district_id: {'_eq': id_district}
            } 
        }
        var resData = await createProvider().defaultClient.mutate({
            mutation: DataServices.getList('ward', {"fields" : "id name"}),
            variables: {
                where_key: where_key
            },
        });
        var dataList = resData[Object.keys(resData)];
        var list_district = (dataList["ward"]) ? dataList["ward"]:[];
        for (var i=0;i<list_district.length;i++){
            list_district[i].value = list_district[i].id;
            list_district[i].label = list_district[i].name;
        }
        return list_district;
    },
    async getWardByIdDistrictSelect(id_district,state_id=null) {
        var model =await this.getWardByIdDistrict(id_district,state_id);
        var arrWard = [];
        if (model.length > 0) {
            for (let i = 0; i < model.length; i++) {
                arrWard.push({'code': model[i].id, 'name': model[i].name})
            }
        }
        return arrWard;
    },
    async getListHoliday() {
        var variables = {
            where_key: {},
            orderBy: []
        }
        var holiday_setting = await this.getListVar('holiday_setting',variables);
        var list = [];
        if (!Common.isEmpty(holiday_setting.holiday_setting)){
            list = holiday_setting.holiday_setting;
        }
        var list_convet =[]
        if (list){
            for (var i =0 ;i<list.length;i++){
                list_convet.push(list[i].date_off.toString());
            }
        }
        return list_convet;
    },
    //async function calcDenta(date_receipt_court,list_holiday) {
     calcDenta(date_start,date_end,list_holiday) {
        var DEFAULT_TIMEZONE = "Asia/Ho_Chi_Minh";
        //var DB_FORMAT_DATE = "UTC";
        var  DB_FORMAT_DATE= "YYYY-MM-DD";
        //Ngày trể tính từ ngày tiếp theo
        var date_end_convert = moment(moment(date_end).tz(DEFAULT_TIMEZONE).format(DB_FORMAT_DATE),DB_FORMAT_DATE).tz(DEFAULT_TIMEZONE);
       // console.log("date_end_convert:",date_end_convert)
        var date_start_convert = moment(moment(date_start).tz(DEFAULT_TIMEZONE).format(DB_FORMAT_DATE),DB_FORMAT_DATE).tz(DEFAULT_TIMEZONE);
       // console.log("date_start_convert:",date_start_convert)
        var count_late_day = date_end_convert.diff(date_start_convert, 'days');
       //  console.log("count_late_day:",count_late_day)
        //Số ngày trễ bắt đầu sau ngày tạo 1 ngày
        if (count_late_day < 1){
            //Nếu ngày hiện tại < 0 || Ngày hiện tại == date_receipt_court => ko có ngày trễ
            count_late_day = 0;
        }
        count_late_day = count_late_day+1;//Cộng thêm 1 lấy luôn ngày hiện tại
        var arr_weekend = [0,6];
        var count_late_result = 0;
        if (count_late_day > 0){
            for (var i=0;i<count_late_day;i++) {
                var date_add = null;
                if (i == 0) {
                    date_add = moment(date_start_convert).tz(DEFAULT_TIMEZONE);
                } else {
                    date_add = moment(date_start_convert).tz(DEFAULT_TIMEZONE).add(i, 'days');
                }
                var data_add_format = new Date(date_add);
               // console.log("data_add_format:",data_add_format)
                var ordinal_day = data_add_format.getDay();
                //day check ngày lễ
                var day_check_holiday = moment(date_add).format(DB_FORMAT_DATE).toString();
                //Nếu tồn tại ngày t7,cn hoặc Ngày lễ thì ko count
                if (!(arr_weekend.indexOf(ordinal_day) == -1) || !(list_holiday.indexOf(day_check_holiday) == -1)  ){
                    //ko count
                  //  console.log("ordinal_day:",ordinal_day)
                  //  console.log("day_check_holiday:",day_check_holiday)
                }else {
                    count_late_result++;
                  //  console.log("count_late_result:",count_late_result)
                }
            }
        }
        return count_late_result;

    }
}
